import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { WhatsappRequest } from '../../requests/chat-ai/whatsapp.request';
import { ReturnStruct } from '../../structs/return.struct';
import { WhatsappResponse } from '../../responses/chat-ai/whatsapp.response';

@Injectable({
  providedIn: 'root',
})
export class WhatsappService extends CommonService {
  constructor(private httpClient: HttpClient) {
    super();
  }

  public getWhatsapp(listaIdEmpresa?: number[]): Observable<WhatsappResponse> {
    let params = new HttpParams();
    (listaIdEmpresa ?? []).forEach(idEmpresa => {
      params = params.append('listaIdEmpresa', idEmpresa);
    });

    return this.httpClient
      .get<WhatsappResponse>(environment.urlApiChatAI + `whatsapp`, { ...this.addHeaderToken(), params })
      .pipe(catchError(this.handleError));
  }

  public incluir(whatsappCadastroRequest: WhatsappRequest): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(
        environment.urlApiChatAI + `whatsapp`,
        whatsappCadastroRequest,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }
}
